import { PythonTopic } from '../../../../types/python-topic';
import { estructurasFuncionesExercises } from './exercises';

export const estructurasFuncionesTopic: PythonTopic = {
  id: 0,
  title: 'Estructuras y funciones',
  description: 'Aprende a crear y usar funciones, trabajar con diferentes tipos de datos, y organizar tu código de forma modular.',
  theory: `# Estructuras y Funciones en Python

## ¿Qué aprenderás en esta sección?

Esta sección te introduce a conceptos fundamentales para organizar y estructurar tu código:

1. **Funciones**: Bloques de código reutilizables
2. **Parámetros y argumentos**: Cómo pasar datos a funciones
3. **Return**: Cómo devolver valores desde funciones
4. **Tipos de datos avanzados**: Tuplas, sets y diccionarios

## ¿Por qué son importantes las funciones?

Las funciones son la base de la programación modular. Te permiten:
- **Reutilizar código**: Escribe una vez, usa muchas veces
- **Organizar**: Separa tu código en unidades lógicas
- **Mantener**: Cambios en un solo lugar
- **Probar**: Fácil probar funciones individualmente

## Tipos de Datos Avanzados

Además de listas, Python tiene otros tipos útiles:
- **Tuplas**: Datos inmutables y ordenados
- **Sets**: Colecciones sin duplicados
- **Diccionarios**: Asociaciones clave-valor

Cada tipo tiene ventajas para diferentes situaciones.

## Estructura de esta sección

Cada ejercicio incluye teoría expandida, ejemplos prácticos y ejercicios para que puedas practicar a tu propio ritmo. Los ejercicios en esta sección tienen validación flexible - solo necesitas que tu código se ejecute correctamente.`,
  difficulty: 'beginner',
  exercises: estructurasFuncionesExercises
};

